import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { apiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MarketplaceService {
  storage = null;
  accessToken = '';
  headers = {};
  constructor(private http: HttpClient) {
    this.storage = localStorage.getItem('at');

    if (this.storage) {
      const decode = atob(this.storage);
      this.accessToken = JSON.parse(decode);
    }

    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };
  }

  addMarketplace(data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'add',
        data: data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/marketplaces`, body);
  }

  getMarketplaces(id_usuario: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_all',
        data: { id_usuario_marketplace: id_usuario },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/marketplaces`, body);
  }
}
